"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRoute = exports.dataUritoBlob = void 0;
var queryString = require('query-string');
function dataUritoBlob(dataUri) {
    var byteString;
    if (dataUri.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataUri.split(',')[1]);
    }
    else {
        byteString = unescape(dataUri.split(',')[1]);
    }
    var mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
}
exports.dataUritoBlob = dataUritoBlob;
function createRoute(args) {
    if (!args.params && !args.query) {
        return args.path;
    }
    var path = Object.entries(args.params || {}).reduce(function (acc, _a) {
        var param = _a[0], value = _a[1];
        return acc.replace(":" + param, value);
    }, args.path);
    if (args.query) {
        return path + "?" + queryString.stringify(args.query);
    }
    return path;
}
exports.createRoute = createRoute;
